<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-acknowledgments element-with-heading" id="acknowledgments">
<div class="heading heading-with-title heading-without-image" id="acknowledgments-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Lori Hays’ Acknowledgments</h1>
</div>
</div>
</div>
</div>
<div class="text" id="acknowledgments-text">
<p class="first first-in-chapter first-full-width">I have so much gratitude for my husband, kids and friends who listened to me whine as I learned the complexities of becoming an author, supported me and sacrificed time with me while I hid away in the writing cave.</p>
<p class="subsq">I would like to thank Naleighna Kai’s Tribe Called Success. Especially our fearless leader Lissa Woodson (Naleighna Kai) and MarZé Scott. Thank you to Lissa for inviting me to be a part of your tribe and recognizing me as someone who could write a book. And for putting up with my insecurities through the process and teaching me so much in such a little time. And huge thanks to MarZé Scott for being willing to jump in immediately when I needed help, guiding me through the process, and agreeing to co-author my first novel with me. Without these two amazing women, <i>Knight of Birmingham</i> may never have happened.</p>
<p class="subsq">Thank you to J. L. Woodson, cover designer extraordinaire. Thank you for to all the tribe members, editors, and beta readers who immediately answered the call when we were racing to the finish-line.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// lori-hays-acknowledgments.vue?81e8adfc